import Vue from "vue";
import Vuex from "vuex";
import { strategyList } from '@/api/strategy'
import { foodList } from '@/api/food'
import { liveList } from '@/api/live'
import { attrList } from '@/api/attr'
import { scenicList } from '@/api/scenic'
import { getMusic, getThumb } from '@/api/config'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    istab: true,
    foodActive: 'food',
    active: 0,
    industrialList: null,
    cultureList: null,
    strategyList: null,
    foodList: null,
    liveList: null,
    attrList: null
  },
  getters: {
    istab: (state) => state.istab,
    cultureList: (state) => state.cultureList,
    industrialList: (state) => state.industrialList,
    strategyList: (state) => state.strategyList,
    foodList: (state) => state.foodList,
    liveList: (state) => state.liveList,
    attrList: (state) => state.attrList,
    foodActive: (state) => state.foodActive,
  },
  mutations: {
    set_food_active: (state, active) => {
      state.foodActive = active;
    },

    set_istab: (state, istab) => {
      state.istab = istab;
    },
    SET_ACTIVE: (state, active) => {
      state.active = active;
    },
    set_industrialList: (state, industrialList) => {
      state.industrialList = industrialList;
    },

    set_cultureList: (state, culture) => {
      state.cultureList = culture;
    },

    set_strategyList: (state, list) => {
      state.strategyList = list
    },

    set_foodList: (state, list) => {
      state.foodList = list
    },

    set_liveList: (state, list) => {
      state.liveList = list
    },

    set_attrList: (state, list) => {
      state.attrList = list
    }

  },
  actions: {

    getMusic({ commit }) {
      getMusic().then((ret) => {
        commit("set_music", ret);
      })
    },

    getThumb({ commit }) {
      getThumb().then((ret) => {
        commit("set_thumb", ret.value);
      })
    },

    // 获取旅游攻略
    strategyList({ commit }) {
      strategyList().then((ret) => {
        commit("set_strategyList", ret);
      })
    },

    // 获取产业线路
    industrialList({ commit }, params) {
      scenicList(params).then((ret) => {
        commit('set_industrialList', ret)
      })
    },

    // 获取文旅线路
    cultureList({ commit }, params) {
      scenicList(params).then((ret) => {
        commit('set_cultureList', ret)
      })
    },

    // 餐饮推荐
    foodList({ commit }) {
      foodList().then((ret) => {
        commit('set_foodList', ret)
      })
    },

    // 住宿推荐
    liveList({ commit }) {
      liveList().then((ret) => {
        commit('set_liveList', ret)
      })
    },

     // 招商
     attrList({ commit }) {
      attrList().then((ret) => {
        commit('set_attrList', ret)
      })
    },
  },
  modules: {},
});
